import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { DashboardClientDetailsResponse } from '../models/client-engagement/dashboardClientDetailsResponse.model';
import { Response } from '../models/common/response.model';
import { DashboardEngagementDetailsResponse } from '../models/client-engagement/dashboardEngagementDetailsResponse.model';
import { HttpResponse } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private readonly baseURL = `${environment.apiUrl}/Client`;
  constructor(private readonly httpClient: HttpClient) { }
  sharingData = new Subject();

  getClientsWithDetails(): Observable<Response<DashboardClientDetailsResponse[]>> {
    return this.httpClient.get<Response<DashboardClientDetailsResponse[]>>(
      this.baseURL + '/clients'
    );
  }

  getClientEngagementsWithDetails(clientId: number): Observable<Response<DashboardEngagementDetailsResponse[]>> {
    return this.httpClient.get<Response<DashboardEngagementDetailsResponse[]>>(`${this.baseURL}/` + `${clientId}/engagements`);

  }

  deleteClient(clientId: number): Observable<Response<null>> {
    return this.httpClient.delete<Response<null>>(`${this.baseURL}/${clientId}`);
  }

  // API call for downloading client usage report data from support user dashboard
  downloadClientUsageReport(): Observable<any> {
    return this.httpClient.get<Blob>(
      `${environment.apiUrl}/AnalysisRun/download-client-usage-report`,
      { observe: 'response', responseType: 'blob' as 'json' });
  }
}
